import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { graphql } from 'react-apollo';

import { overlayClose } from 'shared/actions/view/web';
import { userDidLogin } from 'shared/actions/session';
import jsonSchema from 'shared/json_schemas/userLoginForm';
import { compose, extractFirstErrorMessage } from 'shared/helpers';
import { gqlSubmitLoginForm } from 'shared/gql/auth';

import { mixClasses as cx } from 'helpers/styleHelper';
import { FontIcon, DoubleBouncer, RectButton } from 'components/elems';
import Input from 'components/elems/Input';
import Formation from 'components/utils/Formation';
import { alert } from 'presets';
import manageUserAuthForm, { gqlSubmitFormCfg } from './manageUserAuthForm';



function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    overlayClose,
    userDidLogin,
  }, dispatch);
}


const NormalCopyAboveLoginForm = () => (
  <div className="moa-ff-sans black-70 lh-copy">
    <div className="mt3 mb4">
      You know what to do.
    </div>
  </div>
);


/*
 * UserLoginForm
 */
class UserLoginForm extends React.Component {

  componentWillReceiveProps(nextProps) {
    const { userLogin = {} } = nextProps.respData;

    if (userLogin.jwt) {
      // Succesfully logged in, dispatch to store jwt and update redux.
      // NOTE(t10u): Moved this over here from inside render(), to avoid
      // "Cannot update during an existing state transition..." warning message.
      nextProps.userDidLogin({ jwt: userLogin.jwt });

      // XXX(t10u): Not sure if there is a race condition
      // between above two action dispatches.
      // Also, don't think overlayClose destroys the inner content.
      nextProps.overlayClose();

      // This should trigger DecoratedRoute to redirect to home
      // once successfully logged in.
    }
  }

  render() {
    const props = this.props;

    // GraphQL type as key.
    const { userLogin = {} } = props.respData;

    const errMsg = extractFirstErrorMessage(userLogin.errors);
    const alertDisplay = errMsg ? alert.error(errMsg) : null;

    const btnIcon = (props.isSubmitting ?
      <DoubleBouncer /> :
      <FontIcon type="arrowright" style={{fontSize: '.875rem'}} />
    );

    const {
      copyAboveLoginForm = <NormalCopyAboveLoginForm />,
      stuffBelowLoginForm = null,
    } = props;

    return (
      <div>
        {copyAboveLoginForm}

        <Formation
          formData={props.formData}
          onFocus={props.handleInputOnFocus}
          onChange={props.handleInputOnChange}
          onBlur={props.handleInputOnBlur}
        >
          <Input name="email" shouldFloatLabel={true} wrapClassName="mb2" />
          <Input name="password" type="password" shouldFloatLabel={true} />
        </Formation>

        {alertDisplay &&
          <div className="mt4">
            {alertDisplay}
          </div>
        }

        <div className={cx('mt4 flex justify-end')}>
          <RectButton
            label="LOGIN"
            icon={btnIcon}
            isEnabled={props.validateFormData()}
            isActivated={props.isSubmitting}
            onClick={props.submitForm}
          />
        </div>

        {stuffBelowLoginForm}
      </div>
    );
  }
}

const styles = { };


export default compose(
  connect(null, mapDispatchToProps),
  graphql(gqlSubmitLoginForm, gqlSubmitFormCfg),
  manageUserAuthForm(jsonSchema),
  injectSheet(styles),
)(UserLoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/UserLoginForm.js